// contains custom event names
export const QUICKSHOP_REFRESH = "quickshop:refresh";
export const QUICKSHOP_CLOSE = "quickshop:close";
export const INLINE_CART_SHOW = "inlineCart:show";
export const INLINE_CART_CLOSE = "inlineCart:close";
export const SEARCH_CLOSE = 'search:close';
